import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import App1 from './App1';
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Hls from "hls.js";

import "./index.css";
import "./design/miscellaneous.css";
var cors = require('cors')

// A hard/manual browser refresh reruns this whole file from scratch, but the
// browser keeps window.history.state for the current session-history entry
// across that reload — react-router's BrowserRouter stores it as
// { key, state }, where `state` is whatever was passed to history.push/replace.
// Several Schedule cards (onGoingClassCard.js, scheduledClass.js,
// completedClassCard.js, completedClassTandS.js, onGoingClassTandS.js,
// scheduleClassTandS.js) read scheduleId/activeTab/fromQuizSave/
// fromRecordingPlay off history.location.state on mount to auto-reopen
// ScheduleDetailsDrawer to a specific tab right after an in-app action (e.g.
// saving a quiz, playing a recording). That's fine for in-app navigation, but
// the same leftover state was also reopening the drawer on every hard refresh.
// Stripping just these keys here — before the app ever mounts — makes a
// refresh always land with the drawer closed, without touching any other
// location.state the app may rely on.
(function clearScheduleDrawerStateOnRefresh() {
  try {
    var historyState = window.history && window.history.state;
    var innerState = historyState && historyState.state;
    if (!innerState) return;
    var TRANSIENT_KEYS = ['activeTab', 'scheduleId', 'fromQuizSave', 'fromRecordingPlay'];
    var hasTransientKey = TRANSIENT_KEYS.some((key) => innerState[key] !== undefined);
    if (!hasTransientKey) return;
    var cleanedState = Object.assign({}, innerState);
    TRANSIENT_KEYS.forEach((key) => delete cleanedState[key]);
    window.history.replaceState(
      Object.assign({}, historyState, { state: cleanedState }),
      document.title,
      window.location.href
    );
  } catch (e) {
    // Never let this block app boot.
  }
})();


// react-player does not use the hls.js this app bundles. FilePlayer injects a script tag
// for `https://cdn.jsdelivr.net/npm/hls.js@${hlsVersion}/dist/hls.min.js`, and hlsVersion
// defaults to 1.1.4 (react-player/lib/props.js) — a build from November 2021. Nothing here
// overrode it, so every recording played through ReactPlayerHoc was remuxed by 1.1.4 while
// the live class player (pages/broadcast/hls-player.js, a direct `import Hls from 'hls.js'`)
// used the 1.5.1 in package.json. Same stream, two remuxers, and only one of them carries
// the audio-gap fixes that landed after 1.1.4.
//
// The difference is audible rather than theoretical. Transcoded output leaves small gaps at
// segment seams; mp4-remuxer covers them by injecting silent frames, and 1.1.4 predates that
// path being made reliable — which is why a recording that plays cleanly in any current HLS
// player broke up inside this app. See the maxAudioFramesDrift comment in
// pages/broadcast/playRecordings.js, which describes the same failure from the other end.
//
// getSDK checks window[sdkGlobal] before fetching anything, and FilePlayer passes it no
// isLoaded predicate, so publishing the bundled copy here is all it takes: every
// react-player surface in the app — recordings, class resources, digital library,
// marketplace — picks it up, with no CDN round trip and no second version to drift out of
// step with package.json. Set before render so it is in place ahead of the first player
// mount, and guarded so an Hls already on window still wins.
if (typeof window !== "undefined" && !window.Hls) {
  window.Hls = Hls;
}

Sentry.init({
  dsn: "https://ffb5258a54564054a518820655afc5f4@o932470.ingest.sentry.io/5881205",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
